import React, { useState } from "react";
import IconHidePass from "../../Icons/HidePassword";
import IconInfo from "../../Icons/NotificationMessage/Info";
import IconShowPass from "../../Icons/ShowPassword";
import LoadingSpinner from "../../Loading";
import { ENotificationType } from "../../Model/ENotificationType";
import MtiButton from "../Buttons/MtiButton";
import InlineNotification from "../Common/InlineNotification";
import "./GenerateOtp.css";
import UserApi from "../../api/UserApi";
import { useDispatch } from "react-redux";
import { removeNotification } from "../../redux/actions/NotificationAction";

export type Props = {
  userName: string;
  adminUsername: string;
  onClose: (success: boolean) => void;
};

export default function GenerateOtp({
  userName,
  adminUsername,
  onClose,
}: Props) {
  const dispatch = useDispatch();
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showLoading, setShowLoading] = useState(false);
  const [showWarning, setShowWarning] = useState(true);
  const [userNameError, setUserNameError] = useState(null as string | null);
  const [passwordError, setPasswordError] = useState(null as string | null);

  const onSubmit = () => {
    setShowLoading(true);
    UserApi.generateOtp(userName, {
      userName: adminUsername,
      password: password,
    })
      .then(() => {
        setPasswordError(null);
        onClose(true);
      })
      .catch((error) => {
        dispatch(removeNotification());
        setPasswordError(error);
      })
      .finally(() => {
        setShowLoading(false);
      });
  };

  const toggleShowPass = () => {
    setShowPassword(!showPassword);
  };

  const resetFailStatus = () => {
    setPasswordError(null);
    setUserNameError(null);
  };

  return (
    <div className="generate-otp-form">
      <span className="generate-otp-title">
        Genearate OTP
      </span>
      {showWarning && (
        <div className="generate-otp-warning">
          <InlineNotification
            type={ENotificationType.Warning}
            message="This action will generate One Time Password to change user password."
            onClose={() => setShowWarning(false)}
          />
        </div>
      )}
      <input
        className="generate-otp-username"
        name="username-confirm"
        value={adminUsername}
        placeholder="Username"
        onClick={resetFailStatus}
        disabled={true}
      />

      <div
        className="generate-otp-password"
        tabIndex={2}
        style={{
          marginTop: 16,
        }}
      >
        <input
          className="generate-otp-password-input"
          name="password-confirm"
          type={showPassword ? "text" : "password"}
          placeholder="Confirm Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          onClick={resetFailStatus}
          autoComplete="new-password"
        />
        <button
          onClick={toggleShowPass}
          className="generate-otp-password-button"
        >
          {showPassword && <IconShowPass width="17" height="17" />}
          {!showPassword && <IconHidePass width="17" height="17" />}
        </button>
      </div>

      <div className="generate-otp-fail">
        {passwordError != null && (
          <>
            <IconInfo fill="#C92932" width="10" height="10" />
            <p>{passwordError}</p>
          </>
        )}
      </div>

      <div className="generate-otp-buttons">
        <MtiButton
          size="large"
          onClick={onSubmit}
          disabled={password.trim().length === 0}
        >
          Proceed
        </MtiButton>

        <MtiButton
          variant="secondary"
          size="large"
          onClick={() => onClose(false)}
          style={{ marginRight: "16px" }}
        >
          Cancel
        </MtiButton>
      </div>

      {showLoading && <LoadingSpinner />}
    </div>
  );
}
